export default {
    name: "EventSender",
    methods: {
        fire: (eventName, params) => this.notifyEvent(eventName, params),
        notifyEvent(eventName, params) {
            this.$listenerEventBus.$emit(eventName, params);
        }
    }
}